import { useSelector } from 'react-redux';
import {
  FaChevronDown, FaChevronUp, FaMinusCircle,
} from 'react-icons/fa';
import CircularProgress from '@material-ui/core/CircularProgress';
import PropTypes from 'prop-types';
import { useEffect, useState, memo } from 'react';
import { useAnalytics } from 'use-analytics';
import CarItinerary from '../CarItinerary';
import {
  SearchStatus, InfoPageSize, SearchModeLabel, SearchModes,
} from '../../../../constants';
import TravelBlurbs from '../../../TravelBlurbs';

const CarsList = ({
  onViewMoreClick, isInsideModal, tripId, onModalClose, selectedTab,
}) => {
  const carSearchState = useSelector((state) => state.car.carSearches[tripId].carTabs);
  const trip = useSelector((store) => store.trip.selectedTrips[tripId]);
  const responses = useSelector((state) => state.car.responses);
  const [response, setResponse] = useState(null);
  const { track } = useAnalytics();

  useEffect(() => {
    if (responses) {
      if (carSearchState[selectedTab].queryString) {
        if (trip && trip.rentalCarItineraries && trip.rentalCarItineraries[selectedTab]
          && trip.rentalCarItineraries[selectedTab].legs) {
          setResponse(() => ({
            ...responses[carSearchState[selectedTab].queryString],
            legs: responses[carSearchState[selectedTab].queryString]
              .legs
              .filter((item) => item.uniqueKey
              !== trip.rentalCarItineraries[selectedTab].uniqueKey),
          }));
        } else {
          setResponse(responses[carSearchState[selectedTab].queryString]);
        }
        track('carsList.gotCarSearchResponse', {
          queryString: carSearchState[selectedTab].queryString,
        });
      } else {
        setResponse(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carSearchState, selectedTab, trip]);

  return (
    <>
      {carSearchState
      && carSearchState[selectedTab].searchStatus === SearchStatus.DONE
      && (
        response && response.legs && response.legs.length
          ? (
            <>
              <div>
                <TravelBlurbs type={SearchModeLabel[SearchModes.CAR].toLowerCase()} />
                {response.legs.map((itinerary) => (
                  <CarItinerary
                    key={`${itinerary.id}`}
                    itinerary={itinerary}
                    tripId={tripId}
                    onModalClose={onModalClose}
                    selectedTab={selectedTab}
                  />
                ))}
              </div>
              {response.totalCars > InfoPageSize && (
                <button onClick={onViewMoreClick} type="button" className="border border-theme block rounded-pill text-center rounded-2xl text-x text-theme py-3 mx-auto mb-5 w-64 font-bold">
                  {!isInsideModal
              && (
                <span>
                  View more
                  <FaChevronDown className="inline-block ml-3" />
                </span>
              )}
                  {isInsideModal
              && (
                <span>
                  View less
                  <FaChevronUp className="inline-block ml-3" />
                </span>
              )}
                </button>
              )}
            </>
          )
          : (
            <div className="flex flex-col items-center gap-4">
              <FaMinusCircle size="50" className="text-orange-600" />
              No cars found for your search.
            </div>
          )
      )}
      {(!carSearchState
        || carSearchState[selectedTab].searchStatus === SearchStatus.INITIAL
        || carSearchState[selectedTab].searchStatus === SearchStatus.SEARCHING)
        && (
          <div className="text-center">
            <CircularProgress color="secondary" />
          </div>
        )}
    </>
  );
};

CarsList.propTypes = {
  onViewMoreClick: PropTypes.func.isRequired,
  isInsideModal: PropTypes.bool,
  tripId: PropTypes.string.isRequired,
  selectedTab: PropTypes.number.isRequired,
  onModalClose: PropTypes.func,
};

CarsList.defaultProps = {
  isInsideModal: false,
  onModalClose: undefined,
};

export default memo(CarsList);
